// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"d2e21823","453":"a260093d"}[chunkId] + ".chunk.js";
};